<!--
【圆点图片验证】
事件
属性 	说明 	参数
@imgVerifySuccessCallback 旋转完成,开始业务 
-->

<template>
	<div @click.stop="cancel($event)" class="chineseverify_container "  v-if="showPopup">
		<div class=" ">
			
			<div class="imgverify_head chineseverify_title-padding hidden">
				<slot name="imgverify_head"> 验证操作 </slot>
			</div>
			
			
			<div @click.stop="stopCancel($event)" class="chineseverify_body ">
				<img v-if="chineseverifyImg!='' " :src="chineseverifyImg"
					@click="clickImg" mode="widthFix" 
					class=" autoheight block automargin" 
					:style=" 'width:'+imgWidth+'px;' "/>
				
				<!-- <div class="padding0 width500r automargin relative margint10">
					<div class="absolute width500r borderb_red right0 bottom0 color3 center ">请拖动按钮摆正图片</div>
					<div @touchstart="startTouchBtn" @touchmove="moveTouchBtn" @touchend="endTouchBtn" 
						:style="'margin-left:'+moveLeft+'px;z-index: 2;'" 
						class="ball_btn width50 height50 bg_orange relative radius100" ></div>
				</div> -->
				
			</div>
			
			
			<div class="chineseverify_footer hidden">
				<div class="chineseverify_col" hover-class="chineseverify_hover" v-if="cancelText"
					@click.stop="cancel('cancel')">
					<text :style="cancelStyle" class="chineseverify_row-text">{{cancelText}}</text>
				</div>
				<div :style="confirmStyle" class="hidden chineseverify_col chineseverify_confirm"
					hover-class="chineseverify_hover" @click.stop="confirm">
					<text :style="confirmStyle" class="chineseverify_row-text">{{confirmText}}</text>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	// #ifdef H5
	//import jQuery from "@/common/jquery.js";
	// #endif
	export default {
		name: 'ydverify',
		props: {
			//默认是否显示
			showPopup: {
				type: Boolean,
				default: false
			},
			//取消按钮文字
			cancelText: {
				type: String,
				default: '取消'
			},
			//取消样式
			cancelStyle: {
				type: [String, Object]
			},
			//确定按钮文字
			confirmText: {
				type: String,
				default: '确定'
			},
			//确定样式
			confirmStyle: {
				type: [String, Object]
			},
			//阻止点击对话框外侧锁屏
			disableScreenClick: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				phone:"",
				smsCode:"",//用于证明手机号拥有
				verifyCode:"",//用于证明不是机器操作
				windowHeight:0,
				chineseverifyImg:"",
				imgBoxTop:0,
				imgBoxLeft:0,
				index:0,
				rightArr:[],
				windowTop:0,
				errorCount:0,//错误次数
				rotate:0,//旋转角度
				moveStart:0,
				moveLeft:0,
				imgWidth:0,windowWidth:0,windowHeight:0
			}
		},
		methods: {
			
			initData(){
				
				//界面调整位置
				try {
				    const res = window.$utils.uniapi.getSystemInfoSync();
					console.log("界面调整位置",res);
				    this.windowHeight=res.windowHeight;
					this.windowWidth=res.windowWidth;
				} catch (e) {
				    window.$utils.uniapi.showToast({ title:e });
				}
				
				var imgWidth=this.windowWidth*0.9;
				if(imgWidth>400)imgWidth=400;
				this.imgWidth=imgWidth;
			},
			confirm() {
				this.$emit('confirm');
			},
			stopCancel(e){
				//阻止清除
				e.preventDefault();e.stopPropagation();
			},
			cancel(e) {
				console.log("cancel",e);
				e.preventDefault();
				this.$emit('cancelImgVerify');
			},
			callback(d) {
				// 数据恢复
				this.rightArr=[];
				this.index=0;
				//回调
				this.$emit('imgVerifySuccessCallback',d);
			},
			getVerifyCode(phone){
				console.log("组件 getVerifyCode  isShow="+this.showPopup+"__"+phone);
				//数据恢复
				this.rightArr=[];
				this.index=0;
				this.chineseverifyImg="";
				this.errorCount=0;
				this.phone=phone;
				this.moveLeft=0;
				this.rotate=0;
				window.$utils.uniapi.showLoading({ title:"请稍等...",mask:true });
				this.$axios.request({
					url: window.$config.url.getImgVerifyCode,
					data: {}
				})
				.then(res => {
					console.log("getVerifyCode",res, res.code, window.$config.resCode.SUCCESS);
					window.$utils.uniapi.hideLoading();
					if(!!res.code==true && res.code==window.$config.resCode.SUCCESS){
						
						this.chineseverifyImg=res.data.img;
						this.imgVerifyKey=res.data.imgVerifyKey;
						console.log("getVerifyCode...2". this.chineseverifyImg);
					}else if(!!res.msg==true){
						window.$utils.uniapi.showToast({ title:res.msg,icon:"none" });
					}else{
						window.$utils.uniapi.showToast({ title:"不成功",icon:"none" });
					}
				}).catch(function(){
					window.$utils.uniapi.hideLoading();
				});
			},
			
			
			
			//旋转完成,开始业务
			rotateFinish(e){
				var that=this;
				
				that.callback({
					imgVerifyKey:that.imgVerifyKey,
					imgVerifyVal:that.rotate>360?that.rotate-360:that.rotate
				});
			},
			//废弃，改业务时验证
			checkRotate(e){
				//console.log(e);
				var that=this;
				
				//e.preventDefault();
				
				if(that.errorCount>5){
					that.getVerifyCode(that.phone);return;
				}
				that.errorCount=that.errorCount+1;
				
				that.$axios.request({
					url: window.$config.url.doImgVerify,
					data: {phone:that.phone,imgVerifyKey:that.imgVerifyKey,imgVerifyVal:that.rotate}
				})
				.then(res => {
					if(!!res.code==true && res.code==window.$config.resCode.SUCCESS){
						that.verifyCode=res.data;
						window.$utils.uniapi.showToast({ title:"图片摆正ok",icon:"none" });
						if(typeof that.verifyCode=="object"){
							that.callback(that.verifyCode);//已有键名verifyCode
						}else{
							that.callback({verifyCode:that.verifyCode});//字符串
						}
						
						
						that.errorCount=0;
						
					// }else if(res.code==window.$config.resCode.VERIFY_TIMEOUT){
					// 	window.$utils.uniapi.showToast({ title:res.msg,icon:"none" });
					// 	that.getVerifyCode(that.phone);
					}else if(!!res==true && res.code==window.$config.resCode.ERROR_COUNT_OVER){
						window.$utils.uniapi.showToast({ title:res.msg,icon:"none" });
						//that.getVerifyCode(that.phone);
					}else if(!!res.msg==true){
						window.$utils.uniapi.showToast({ title:res.msg,icon:"none" });
						that.getVerifyCode(that.phone);
					}else{
						window.$utils.uniapi.showToast({ title:"不成功",icon:"none" });
						that.getVerifyCode(that.phone);
					}
					
				});
				
			},
			clickImg(e){
				e.preventDefault(); e.stopPropagation();
				
				var that=this;
				console.log("点击位置",e,e.clientY);
				//offsetX: offsetY:  clientX: clientY:（不含滚动）  pageX:  pageY（含gundong） screenX: screenY:   

				//that.$refs.operate_popup.close();
				
				var x=e.clientX;
				var y=e.clientY;
				var offset_x=(this.windowWidth-this.imgWidth)/2;
				var offset_y=(this.windowHeight-this.imgWidth)/2;
				x=parseInt((x-offset_x)/this.imgWidth*100);
				y=parseInt((y-offset_y)/this.imgWidth*100);
				var val=x+","+y;
				console.log("点击位置："+val+"点击x："+x+" 点击y："+y+"点击offset_x："+offset_x+"点击offset_y："+offset_y+"   this.windowWidth-this.imgWidth="+this.windowWidth+"----"+this.imgWidth);

				
				// this.imgVerifyCallback({
				// 	imgVerifyKey:that.imgVerifyKey,
				// 	imgVerifyVal:val,
				// 	});
				that.callback({
					imgVerifyKey:that.imgVerifyKey,
					imgVerifyVal:val
				});
			},
			//开始旋转
			startTouchBtn(e){
				e.preventDefault(); e.stopPropagation();
				console.log("start touch");
				console.log(e.touches[0].pageX);
				this.moveStart=e.touches[0].pageX;
			},
			moveTouchBtn(e){
				e.preventDefault();e.stopPropagation();
				console.log(e.touches[0].pageX);
				this.moveLeft=e.touches[0].pageX>this.moveStart?(e.touches[0].pageX-this.moveStart):0;
				this.rotate=this.moveLeft*2;
				//this.moveEnd=e.touches[0].pageX;
			},
			endTouchBtn(e){
				e.preventDefault();e.stopPropagation();
				console.log(e);
				console.log("提交"+this.rotate);
				// this.checkRotate();
				this.rotateFinish();
			},
			
			h5EventInit(){
				// #ifdef H5
				//window.$utils.uniapi.showLoading();
				var _isDown = false;
				var that = this;
				//开始事件
				window.$(document).on('mousedown', '.ball_btn', function(e){
					console.log("mouse-down");
					if(!_isDown) _isDown = true;
					e.preventDefault(); e.stopPropagation();
					that.moveStart=e.pageX;
				});
				//移动事件
				window.$(document).on('mousemove', '.ball_btn', function(e){
					e.preventDefault();e.stopPropagation();
					if(_isDown){
						that.moveLeft=e.pageX>that.moveStart?(e.pageX-that.moveStart):0;
						that.rotate=that.moveLeft*2;
					}
				});
				//结束事件
				window.$(document).on('mouseup', '.ball_btn', function(e){
					console.log('mouse-up');
					e.preventDefault();e.stopPropagation();
					_isDown=false;
					that.rotateFinish();
				});
				//setTimeout(function(){window.$utils.uniapi.hideLoading();},1500);
				// #endif
			},
			
			
			/**
			 * 获取组件宽高
			 * @param {Object} element ".class or #id"
			 */
			getSize(element){
				
				  return new Promise((resolve, reject) => {
					  
					  //H5端获得控件的宽度
					  // #ifdef H5
					  console.log("in H5");
					  let width= this.$el.querySelector(element).clientWidth;
					  let height= this.$el.querySelector(element).clientHeight;
					  resolve({code:1000,msg:"成功",data:{width:width,height:height}});return;
					  // #endif
					  
					  
					//   //微信小程序获得控件的宽度
					//   // #ifdef APP-PLUS || MP
					//   console.log("MP || APP_PLUS");
					//   let width= 0;let height= 0;
					//   var query = this.createSelectorQuery();
					//   query.select(element).boundingClientRect(
					//   	function(rect){
					// 		console.log(rect);
					//   		if(rect.width){
					//   		  width=rect.width;
					//   		  height=rect.height;
					//   		  resolve({code:1000,msg:"成功",data:rect});return;
					//   		}
					//   	}).exec();
					//   // #endif
					  
					  
					  //reject({code:9999,msg:"获得控件宽度不成功",data:null});return;
					  
				});
											
				
				
			}
		},
		mounted() {
			
			console.log('ydverify mounted');
			var sysinfo=window.$utils.uniapi.getSystemInfoSync();
			this.windowTop=sysinfo.windowTop || 0;
			this.windowWidth=sysinfo.windowWidth || 0;
			this.windowHeight=sysinfo.windowHeight || 0;
			console.log(sysinfo);
			console.log(this.showPopup);
			
			
			this.initData();
			if(this.showPopup)this.getVerifyCode();
			
			
			// #ifdef APP-PLUS
			//在普通的 H5+ 项目中，需要使用 document.addEventListener 监听原生扩展的事件。
			//uni-app 中，没有 document。可以使用 plus.globalEvent.addEventListener 来实现（注意manifest中需开启新编译器，即自定义组件模式"usingComponents":true）。
			// plus.globalEvent.addEventListener('click', function(e){
			// 	console.log("kkkkkkk-----");console.log(e);
			// });
			
			
			// #endif
			
			// #ifdef H5
			this.h5EventInit();
			// #endif
			
		}
	}
</script>
<style scoped>
	.chineseverify_container {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999;
		background-color: rgba(0, 0, 0, 0.9);
		transition: all 5s;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.chineseverify_content {
		width: 90%;
		max-width: 500px;
		xxborder-radius: 26rpx;
		background: none;
		overflow: hidden;
		animation: fadeZoom .15s linear;
		
	}

	.imgverify_head {
		padding: 30rpx 30rpx 0;
		text-align: center;
		color: #000;
		font-size: 17px;
		font-weight: 700;
	}

	.chineseverify_title-padding {
		padding-bottom: 30rpx;
	}

	.chineseverify_body {
		overflow: auto;
		xxxpadding: 40rpx 30rpx;
		font-size: 15px;
		color: #000;
		text-align: center;
		
	}

	.chineseverify_footer {
		display: flex;
		position: relative;
		text-align: center;
		font-size: 17px;
		line-height: 100rpx;
		color: #007AFF;
		border-top: 0.5px solid rgba(9, 20, 31, 0.13);
	}

	.chineseverify_col {
		flex: 1;
		width: 100%;
		position: relative;
	}

	.chineseverify_col:first-child::after {
		content: '';
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		border-right: 1px solid rgba(9, 20, 31, 0.13);
		transform: scaleX(.36);
	}

	.chineseverify_confirm {
		color: rgb(0, 122, 255);
	}

	.chineseverify_hover {
		background-color: #f2f2f2;
	}


	.chineseverify_footer::after {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		border-top: 0.5px solid rgba(9, 20, 31, 0.13);
		transform: scaleY(.36);
	}


	@keyframes fadeZoom {
		0% {
			transform: scale(.7);
			opacity: .6;
		}

		80% {
			transform: scale(1.2);
			opacity: .3;
		}

		100% {
			transform: scale(1);
			opacity: 1;
		}
	}
	
</style>



// WEBPACK FOOTER //
// src/components/imgverify/ydverify.vue